export default "assets/images/texture_papier_2-396a4bdc.png";